import { render, staticRenderFns } from "./solutionList.vue?vue&type=template&id=22bf0ec4&scoped=true"
import script from "./solutionList.vue?vue&type=script&lang=js"
export * from "./solutionList.vue?vue&type=script&lang=js"
import style0 from "./solutionList.vue?vue&type=style&index=0&id=22bf0ec4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22bf0ec4",
  null
  
)

export default component.exports